import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { createReducer, on, Action } from '@ngrx/store';

import { RefTypeItem } from '@sd-portal/shared/ref-type-item';
import { auditLogAdapter, refTypeItemAdapter } from '../shared-audit.adapters';
import {
  PostedFlightSkeleton,
  PostedFlightAuditLog,
  FlightCrewMemberAuditLog,
  LogbookApproachAuditLog,
  FlightPassengerAuditLog,
  ExpenseAuditLog,
  PostedFlightEngineAuditLog,
  PostedFlightComponentAuditLog,
  PostedFlightFuelAuditLog,
  PostedFlightAdditionalDetailAuditLog,
  PostedFlightDeAntiIceAuditLog,
  PostedFlightNotesAuditLog,
  EngineOilFluidAuditLog,
  ComponentOilFluidAuditLog,
  OilFluidAuditLog,
  FuelUpliftAuditLog,
  BusinessCategoryAuditLog,
  DepartmentAuditLog,
  LogbookAuditLog,
  CrewMemberDutyAuditLog,
  AirFrameLandingsAuditLog,
  EngineCyclesAuditLog,
  VORCheckDataAuditLog,
  PreFlightChecklistUserESignaturesAuditLog,
  PostedFlightChecklistUserESignaturesAuditLog,
  FlightLogUserESignaturesAuditLog,
  SquawkUserESignaturesAuditLog,
  FlightBusinessPersonAuditLog
} from '../../+models/posted-flight.audit.model';
import * as actions from './posted-flight.actions';

// States
interface ApproachTypeEntityState extends EntityState<RefTypeItem> {
  loading: boolean;
  loaded: boolean;
  error: any; // eslint-disable-line @typescript-eslint/no-explicit-any
}

interface ExpenseCategoryTypeState extends EntityState<RefTypeItem> {
  loading: boolean;
  loaded: boolean;
  error: any; // eslint-disable-line @typescript-eslint/no-explicit-any
}

interface PostedFlightSkeletonState extends EntityState<PostedFlightSkeleton> {
  loading: boolean;
  loaded: boolean;
  error: any; // eslint-disable-line @typescript-eslint/no-explicit-any
}

interface PostedFlightAuditState extends EntityState<PostedFlightAuditLog> {
  loading: boolean;
  loaded: boolean;
  error: any; // eslint-disable-line @typescript-eslint/no-explicit-any
  selectedId: number | null;
  pageNumber: number;
  lastAuditLogId: number | null;
}

interface FlightCrewMemberAuditState extends EntityState<FlightCrewMemberAuditLog> {
  loading: boolean;
  loaded: boolean;
  error: any; // eslint-disable-line @typescript-eslint/no-explicit-any
  selectedId: number | null;
  pageNumber: number;
  lastAuditLogId: number | null;
}

interface FlightBusinessPersonAuditState extends EntityState<FlightBusinessPersonAuditLog> {
  loading: boolean;
  loaded: boolean;
  error: any; // eslint-disable-line @typescript-eslint/no-explicit-any
  selectedId: number | null;
  pageNumber: number;
  lastAuditLogId: number | null;
}

interface LogbookApproachAuditState extends EntityState<LogbookApproachAuditLog> {
  loading: boolean;
  loaded: boolean;
  error: any; // eslint-disable-line @typescript-eslint/no-explicit-any
  selectedId: number | null;
  pageNumber: number;
  lastAuditLogId: number | null;
}

interface FlightPassengerAuditState extends EntityState<FlightPassengerAuditLog> {
  loading: boolean;
  loaded: boolean;
  error: any; // eslint-disable-line @typescript-eslint/no-explicit-any
  selectedId: number | null;
  pageNumber: number;
  lastAuditLogId: number | null;
}

interface ExpenseAuditState extends EntityState<ExpenseAuditLog> {
  loading: boolean;
  loaded: boolean;
  error: any; // eslint-disable-line @typescript-eslint/no-explicit-any
  selectedId: number | null;
  pageNumber: number;
  lastAuditLogId: number | null;
}

interface PostedFlightEngineAuditState extends EntityState<PostedFlightEngineAuditLog> {
  loading: boolean;
  loaded: boolean;
  error: any; // eslint-disable-line @typescript-eslint/no-explicit-any
  selectedId: number | null;
  pageNumber: number;
  lastAuditLogId: number | null;
}

interface PostedFlightComponentAuditState extends EntityState<PostedFlightComponentAuditLog> {
  loading: boolean;
  loaded: boolean;
  error: any; // eslint-disable-line @typescript-eslint/no-explicit-any
  selectedId: number | null;
  pageNumber: number;
  lastAuditLogId: number | null;
}

interface PostedFlightFuelAuditState extends EntityState<PostedFlightFuelAuditLog> {
  loading: boolean;
  loaded: boolean;
  error: any; // eslint-disable-line @typescript-eslint/no-explicit-any
  selectedId: number | null;
  pageNumber: number;
  lastAuditLogId: number | null;
}

interface PostedFlightAdditionalDetailAuditState
  extends EntityState<PostedFlightAdditionalDetailAuditLog> {
  loading: boolean;
  loaded: boolean;
  error: any; // eslint-disable-line @typescript-eslint/no-explicit-any
  selectedId: number | null;
  pageNumber: number;
  lastAuditLogId: number | null;
}

interface OilFluidAuditState extends EntityState<OilFluidAuditLog> {
  loading: boolean;
  loaded: boolean;
  error: any; // eslint-disable-line @typescript-eslint/no-explicit-any
  selectedId: number | null;
  pageNumber: number;
  lastAuditLogId: number | null;
}

interface EngineOilFluidAuditState extends EntityState<EngineOilFluidAuditLog> {
  loading: boolean;
  loaded: boolean;
  error: any; // eslint-disable-line @typescript-eslint/no-explicit-any
  selectedId: number | null;
  pageNumber: number;
  lastAuditLogId: number | null;
}

interface ComponentOilFluidAuditState extends EntityState<ComponentOilFluidAuditLog> {
  loading: boolean;
  loaded: boolean;
  error: any; // eslint-disable-line @typescript-eslint/no-explicit-any
  selectedId: number | null;
  pageNumber: number;
  lastAuditLogId: number | null;
}

interface PostedFlightDeAntiIceAuditState extends EntityState<PostedFlightDeAntiIceAuditLog> {
  loading: boolean;
  loaded: boolean;
  error: any; // eslint-disable-line @typescript-eslint/no-explicit-any
  selectedId: number | null;
  pageNumber: number;
  lastAuditLogId: number | null;
}

interface PostedFlightNotesAuditState extends EntityState<PostedFlightNotesAuditLog> {
  loading: boolean;
  loaded: boolean;
  error: any; // eslint-disable-line @typescript-eslint/no-explicit-any
  selectedId: number | null;
  pageNumber: number;
  lastAuditLogId: number | null;
}

interface FuelUpliftAuditState extends EntityState<FuelUpliftAuditLog> {
  loading: boolean;
  loaded: boolean;
  error: any; // eslint-disable-line @typescript-eslint/no-explicit-any
  selectedId: number | null;
  pageNumber: number;
  lastAuditLogId: number | null;
}

interface BusinessCategoryAuditState extends EntityState<BusinessCategoryAuditLog> {
  loading: boolean;
  loaded: boolean;
  error: any; // eslint-disable-line @typescript-eslint/no-explicit-any
  selectedId: number | null;
  pageNumber: number;
  lastAuditLogId: number | null;
}

interface DepartmentAuditState extends EntityState<DepartmentAuditLog> {
  loading: boolean;
  loaded: boolean;
  error: any; // eslint-disable-line @typescript-eslint/no-explicit-any
  selectedId: number | null;
  pageNumber: number;
  lastAuditLogId: number | null;
}

interface LogbookAuditState extends EntityState<LogbookAuditLog> {
  loading: boolean;
  loaded: boolean;
  error: any; // eslint-disable-line @typescript-eslint/no-explicit-any
  selectedId: number | null;
  pageNumber: number;
  lastAuditLogId: number | null;
}

interface CrewMemberDutyAuditState extends EntityState<CrewMemberDutyAuditLog> {
  loading: boolean;
  loaded: boolean;
  error: any; // eslint-disable-line @typescript-eslint/no-explicit-any
  selectedId: number | null;
  pageNumber: number;
  lastAuditLogId: number | null;
}

interface AirFrameLandingsAuditState extends EntityState<AirFrameLandingsAuditLog> {
  loading: boolean;
  loaded: boolean;
  error: any; // eslint-disable-line @typescript-eslint/no-explicit-any
  selectedId: number | null;
  pageNumber: number;
  lastAuditLogId: number | null;
}

interface EngineCyclesAuditState extends EntityState<EngineCyclesAuditLog> {
  loading: boolean;
  loaded: boolean;
  error: any; // eslint-disable-line @typescript-eslint/no-explicit-any
  selectedId: number | null;
  pageNumber: number;
  lastAuditLogId: number | null;
}

interface VORCheckDataAuditState extends EntityState<VORCheckDataAuditLog> {
  loading: boolean;
  loaded: boolean;
  error: any; // eslint-disable-line @typescript-eslint/no-explicit-any
  selectedId: number | null;
  pageNumber: number;
  lastAuditLogId: number | null;
}

interface PreFlightChecklistUserESiganturesAuditState
  extends EntityState<PreFlightChecklistUserESignaturesAuditLog> {
  loading: boolean;
  loaded: boolean;
  error: any; // eslint-disable-line @typescript-eslint/no-explicit-any
  selectedId: number | null;
  pageNumber: number;
  lastAuditLogId: number | null;
}

interface PostedFlightChecklistUserESiganturesAuditState
  extends EntityState<PostedFlightChecklistUserESignaturesAuditLog> {
  loading: boolean;
  loaded: boolean;
  error: any; // eslint-disable-line @typescript-eslint/no-explicit-any
  selectedId: number | null;
  pageNumber: number;
  lastAuditLogId: number | null;
}

interface FlightLogUserESignaturesAuditState extends EntityState<FlightLogUserESignaturesAuditLog> {
  loading: boolean;
  loaded: boolean;
  error: any; // eslint-disable-line @typescript-eslint/no-explicit-any
  selectedId: number | null;
  pageNumber: number;
  lastAuditLogId: number | null;
}

interface SquawkUserESignaturesAuditState extends EntityState<SquawkUserESignaturesAuditLog> {
  loading: boolean;
  loaded: boolean;
  error: any; // eslint-disable-line @typescript-eslint/no-explicit-any
  selectedId: number | null;
  pageNumber: number;
  lastAuditLogId: number | null;
}

// Adapters
const expenseCategoryTypeAdapter = createEntityAdapter<RefTypeItem>({
  selectId: p => p.id
});

const postedFlightSkeletonAdapter = createEntityAdapter<PostedFlightSkeleton>({
  selectId: p => p.postedFlightId
});

// Entity selectors
export const expenseCategoryTypeSelectors = expenseCategoryTypeAdapter.getSelectors();
export const postedFlightSkeletonSelectors = postedFlightSkeletonAdapter.getSelectors();

// Initial states
const initialPagedState = {
  loading: false,
  loaded: false,
  error: null,
  selectedId: null,
  pageNumber: 1,
  lastAuditLogId: null
};

const approachTypesInitialState = refTypeItemAdapter.getInitialState({
  loading: false,
  loaded: false,
  error: null
});

const expenseCategoryTypesInitialState = expenseCategoryTypeAdapter.getInitialState({
  loading: false,
  loaded: false,
  error: null
});

const postedFlightSkeletonInitialState = postedFlightSkeletonAdapter.getInitialState({
  loading: false,
  loaded: false,
  error: null
});

const postedFlightAuditInitialState = auditLogAdapter.getInitialState(initialPagedState);
const flightCrewMemberAuditInitialState = auditLogAdapter.getInitialState(initialPagedState);
const flightBusinessPersonAuditInitialState = auditLogAdapter.getInitialState(initialPagedState);
const logbookApproachAuditInitialState = auditLogAdapter.getInitialState(initialPagedState);
const flightPassengerAuditInitialState = auditLogAdapter.getInitialState(initialPagedState);
const expenseAuditInitialState = auditLogAdapter.getInitialState(initialPagedState);
const postedFlightEngineAuditInitialState = auditLogAdapter.getInitialState(initialPagedState);
const postedFlightComponentAuditInitialState = auditLogAdapter.getInitialState(initialPagedState);
const postedFlightFuelAuditInitialState = auditLogAdapter.getInitialState(initialPagedState);
const postedFlightAdditionalDetailAuditInitialState =
  auditLogAdapter.getInitialState(initialPagedState);
const oilFluidAuditInitialState = auditLogAdapter.getInitialState(initialPagedState);
const engineOilFluidAuditInitialState = auditLogAdapter.getInitialState(initialPagedState);
const componentOilFluidAuditInitialState = auditLogAdapter.getInitialState(initialPagedState);
const postedFlightDeAntiIceAuditInitialState = auditLogAdapter.getInitialState(initialPagedState);
const postedFlightNotesAuditInitialState = auditLogAdapter.getInitialState(initialPagedState);
const fuelUpliftAuditInitialState = auditLogAdapter.getInitialState(initialPagedState);
const businessCategoryAuditInitialState = auditLogAdapter.getInitialState(initialPagedState);
const departmentAuditInitialState = auditLogAdapter.getInitialState(initialPagedState);
const logbookAuditInitialState = auditLogAdapter.getInitialState(initialPagedState);
const crewMemberDutyAuditInitialState = auditLogAdapter.getInitialState(initialPagedState);
const airframeLandingsAuditInitialState = auditLogAdapter.getInitialState(initialPagedState);
const engineCyclesAuditInitialState = auditLogAdapter.getInitialState(initialPagedState);
const vorcheckDataAuditInitialState = auditLogAdapter.getInitialState(initialPagedState);
const preFlightChecklistUserESiganturesAuditState =
  auditLogAdapter.getInitialState(initialPagedState);
const postedFlightChecklistUserESiganturesAuditState =
  auditLogAdapter.getInitialState(initialPagedState);
const flightLogUserESignaturesAuditState = auditLogAdapter.getInitialState(initialPagedState);
const squawkUserESiganturesAuditState = auditLogAdapter.getInitialState(initialPagedState);

export interface State {
  approachTypes: ApproachTypeEntityState;
  expenseCategoryTypes: ExpenseCategoryTypeState;
  postedFlightSkeleton: PostedFlightSkeletonState;
  postedFlightAudit: PostedFlightAuditState;
  flightCrewMemberAudit: FlightCrewMemberAuditState;
  flightBusinessPersonAudit: FlightBusinessPersonAuditState;
  logbookApproachAudit: LogbookApproachAuditState;
  flightPassengerAudit: FlightPassengerAuditState;
  expenseAudit: ExpenseAuditState;
  postedFlightEngineAudit: PostedFlightEngineAuditState;
  postedFlightComponentAudit: PostedFlightComponentAuditState;
  postedFlightFuelAudit: PostedFlightFuelAuditState;
  postedFlightAdditionalDetailAudit: PostedFlightAdditionalDetailAuditState;
  oilFluidAudit: OilFluidAuditState;
  engineOilFluidAudit: EngineOilFluidAuditState;
  componentOilFluidAudit: ComponentOilFluidAuditState;
  postedFlightDeAntiIceAudit: PostedFlightDeAntiIceAuditState;
  postedFlightNotesAudit: PostedFlightNotesAuditState;
  fuelUpliftAudit: FuelUpliftAuditState;
  businessCategoryAudit: BusinessCategoryAuditState;
  departmentAudit: DepartmentAuditState;
  logbookAudit: LogbookAuditState;
  crewMemberDutyAudit: CrewMemberDutyAuditState;
  airframeLandingsAudit: AirFrameLandingsAuditState;
  engineCyclesAudit: EngineCyclesAuditState;
  vorcheckDataAudit: VORCheckDataAuditState;
  preFlightChecklistUserESignaturesAudit: PreFlightChecklistUserESiganturesAuditState;
  postedFlightChecklistUserESignaturesAudit: PostedFlightChecklistUserESiganturesAuditState;
  flightLogUserESignaturesAudit: FlightLogUserESignaturesAuditState;
  squawkUserESignaturesAudit: SquawkUserESignaturesAuditState;
}

const initialState: State = {
  approachTypes: approachTypesInitialState,
  expenseCategoryTypes: expenseCategoryTypesInitialState,
  postedFlightSkeleton: postedFlightSkeletonInitialState,
  postedFlightAudit: postedFlightAuditInitialState,
  flightCrewMemberAudit: flightCrewMemberAuditInitialState,
  flightBusinessPersonAudit: flightBusinessPersonAuditInitialState,
  logbookApproachAudit: logbookApproachAuditInitialState,
  flightPassengerAudit: flightPassengerAuditInitialState,
  expenseAudit: expenseAuditInitialState,
  postedFlightEngineAudit: postedFlightEngineAuditInitialState,
  postedFlightComponentAudit: postedFlightComponentAuditInitialState,
  postedFlightFuelAudit: postedFlightFuelAuditInitialState,
  postedFlightAdditionalDetailAudit: postedFlightAdditionalDetailAuditInitialState,
  oilFluidAudit: oilFluidAuditInitialState,
  engineOilFluidAudit: engineOilFluidAuditInitialState,
  componentOilFluidAudit: componentOilFluidAuditInitialState,
  postedFlightDeAntiIceAudit: postedFlightDeAntiIceAuditInitialState,
  postedFlightNotesAudit: postedFlightNotesAuditInitialState,
  fuelUpliftAudit: fuelUpliftAuditInitialState,
  businessCategoryAudit: businessCategoryAuditInitialState,
  departmentAudit: departmentAuditInitialState,
  logbookAudit: logbookAuditInitialState,
  crewMemberDutyAudit: crewMemberDutyAuditInitialState,
  airframeLandingsAudit: airframeLandingsAuditInitialState,
  engineCyclesAudit: engineCyclesAuditInitialState,
  vorcheckDataAudit: vorcheckDataAuditInitialState,
  preFlightChecklistUserESignaturesAudit: preFlightChecklistUserESiganturesAuditState,
  postedFlightChecklistUserESignaturesAudit: postedFlightChecklistUserESiganturesAuditState,
  flightLogUserESignaturesAudit: flightLogUserESignaturesAuditState,
  squawkUserESignaturesAudit: squawkUserESiganturesAuditState
};

const postedFlightReducer = createReducer<State>(
  initialState,
  on(actions.ResetPostedFlight, () => initialState),

  on(actions.LoadApproachTypes, state => ({
    ...state,
    approachTypes: {
      ...state.approachTypes,
      loading: true,
      loaded: false,
      error: null
    }
  })),

  on(actions.ApproachTypesLoaded, (state, action) => ({
    ...state,
    approachTypes: {
      ...state.approachTypes,
      ...refTypeItemAdapter.setAll(action.payload, state.approachTypes),
      loading: false,
      loaded: true,
      error: null
    }
  })),

  on(actions.LoadExpenseCategoryTypes, state => ({
    ...state,
    expenseCategoryTypes: {
      ...state.expenseCategoryTypes,
      loading: true,
      loaded: false,
      error: null
    }
  })),

  on(actions.ExpenseCategoryTypesLoaded, (state, action) => ({
    ...state,
    expenseCategoryTypes: {
      ...state.expenseCategoryTypes,
      ...expenseCategoryTypeAdapter.setAll(action.payload, state.expenseCategoryTypes),
      loading: false,
      loaded: true,
      error: null
    }
  })),

  on(actions.LoadPostedFlightSkeleton, state => ({
    ...state,
    postedFlightSkeleton: {
      ...state.postedFlightSkeleton,
      loading: true,
      loaded: false,
      error: null
    }
  })),

  on(actions.PostedFlightSkeletonLoaded, (state, action) => ({
    ...state,
    postedFlightSkeleton: {
      ...state.postedFlightSkeleton,
      ...postedFlightSkeletonAdapter.addOne(action.payload, state.postedFlightSkeleton),
      loading: false,
      loaded: true,
      error: null
    }
  })),

  on(actions.LoadPostedFlightAudit, (state, action) => ({
    ...state,
    postedFlightAudit: {
      ...state.postedFlightAudit,
      loading: true,
      loaded: false,
      error: null,
      lastAuditLogId:
        action.postedFlightId === state.postedFlightAudit.selectedId
          ? state.postedFlightAudit.lastAuditLogId
          : null
    }
  })),

  on(actions.PostedFlightAuditLoaded, (state, action) => ({
    ...state,
    postedFlightAudit: {
      ...state.postedFlightAudit,
      ...(!state.postedFlightAudit.lastAuditLogId
        ? auditLogAdapter.setAll(action.audits.resultSet, state.postedFlightAudit)
        : auditLogAdapter.addMany(action.audits.resultSet, state.postedFlightAudit)),
      loading: false,
      loaded: true,
      error: null,
      selectedId: action.postedFlightId,
      pageNumber: action.audits.pageNumber,
      lastAuditLogId: Math.min(...action.audits.resultSet.map(r => +r.auditLogId))
    }
  })),

  on(actions.LoadFlightCrewMemberAudit, (state, action) => ({
    ...state,
    flightCrewMemberAudit: {
      ...state.flightCrewMemberAudit,
      loading: true,
      loaded: false,
      error: null,
      lastAuditLogId:
        action.flightCrewMemberId === state.flightCrewMemberAudit.selectedId
          ? state.flightCrewMemberAudit.lastAuditLogId
          : null
    }
  })),

  on(actions.FlightCrewMemberAuditLoaded, (state, action) => ({
    ...state,
    flightCrewMemberAudit: {
      ...state.flightCrewMemberAudit,
      ...(!state.flightCrewMemberAudit.lastAuditLogId
        ? auditLogAdapter.setAll(action.audits.resultSet, state.flightCrewMemberAudit)
        : auditLogAdapter.addMany(action.audits.resultSet, state.flightCrewMemberAudit)),
      loading: false,
      loaded: true,
      error: null,
      selectedId: action.flightCrewMemberId,
      pageNumber: action.audits.pageNumber,
      lastAuditLogId: Math.min(...action.audits.resultSet.map(r => +r.auditLogId))
    }
  })),

  on(actions.LoadFlightBusinessPersonAudit, (state, action) => ({
    ...state,
    flightBusinessPersonAudit: {
      ...state.flightBusinessPersonAudit,
      loading: true,
      loaded: false,
      error: null,
      lastAuditLogId:
        action.flightBusinessPersonId === state.flightBusinessPersonAudit.selectedId
          ? state.flightBusinessPersonAudit.lastAuditLogId
          : null
    }
  })),

  on(actions.FlightBusinessPersonAuditLoaded, (state, action) => ({
    ...state,
    flightBusinessPersonAudit: {
      ...state.flightBusinessPersonAudit,
      ...(!state.flightBusinessPersonAudit.lastAuditLogId
        ? auditLogAdapter.setAll(action.audits.resultSet, state.flightBusinessPersonAudit)
        : auditLogAdapter.addMany(action.audits.resultSet, state.flightBusinessPersonAudit)),
      loading: false,
      loaded: true,
      error: null,
      selectedId: action.flightBusinessPersonId,
      pageNumber: action.audits.pageNumber,
      lastAuditLogId: Math.min(...action.audits.resultSet.map(r => +r.auditLogId))
    }
  })),

  on(actions.LoadLogbookApproachAudit, (state, action) => ({
    ...state,
    logbookApproachAudit: {
      ...state.logbookApproachAudit,
      loading: true,
      loaded: false,
      error: null,
      lastAuditLogId:
        action.logbookApproachId === state.logbookApproachAudit.selectedId
          ? state.logbookApproachAudit.lastAuditLogId
          : null
    }
  })),

  on(actions.LogbookApproachAuditLoaded, (state, action) => ({
    ...state,
    logbookApproachAudit: {
      ...state.logbookApproachAudit,
      ...(!state.logbookApproachAudit.lastAuditLogId
        ? auditLogAdapter.setAll(action.audits.resultSet, state.logbookApproachAudit)
        : auditLogAdapter.addMany(action.audits.resultSet, state.logbookApproachAudit)),
      loading: false,
      loaded: true,
      error: null,
      selectedId: action.logbookApproachId,
      pageNumber: action.audits.pageNumber,
      lastAuditLogId: Math.min(...action.audits.resultSet.map(r => +r.auditLogId))
    }
  })),

  on(actions.LoadFlightPassengerAudit, (state, action) => ({
    ...state,
    flightPassengerAudit: {
      ...state.flightPassengerAudit,
      loading: true,
      loaded: false,
      error: null,
      lastAuditLogId:
        action.flightPassengerId === state.flightPassengerAudit.selectedId
          ? state.flightPassengerAudit.lastAuditLogId
          : null
    }
  })),

  on(actions.FlightPassengerAuditLoaded, (state, action) => ({
    ...state,
    flightPassengerAudit: {
      ...state.flightPassengerAudit,
      ...(!state.flightPassengerAudit.lastAuditLogId
        ? auditLogAdapter.setAll(action.audits.resultSet, state.flightPassengerAudit)
        : auditLogAdapter.addMany(action.audits.resultSet, state.flightPassengerAudit)),
      loading: false,
      loaded: true,
      error: null,
      selectedId: action.flightPassengerId,
      pageNumber: action.audits.pageNumber,
      lastAuditLogId: Math.min(...action.audits.resultSet.map(r => +r.auditLogId))
    }
  })),

  on(actions.LoadExpenseAudit, (state, action) => ({
    ...state,
    expenseAudit: {
      ...state.expenseAudit,
      loading: true,
      loaded: false,
      error: null,
      lastAuditLogId:
        action.expenseId === state.expenseAudit.selectedId
          ? state.expenseAudit.lastAuditLogId
          : null
    }
  })),

  on(actions.ExpenseAuditLoaded, (state, action) => ({
    ...state,
    expenseAudit: {
      ...state.expenseAudit,
      ...(!state.expenseAudit.lastAuditLogId
        ? auditLogAdapter.setAll(action.audits.resultSet, state.expenseAudit)
        : auditLogAdapter.addMany(action.audits.resultSet, state.expenseAudit)),
      loading: false,
      loaded: true,
      error: null,
      selectedId: action.expenseId,
      pageNumber: action.audits.pageNumber,
      lastAuditLogId: Math.min(...action.audits.resultSet.map(r => +r.auditLogId))
    }
  })),

  on(actions.LoadPostedFlightEngineAudit, (state, action) => ({
    ...state,
    postedFlightEngineAudit: {
      ...state.postedFlightEngineAudit,
      loading: true,
      loaded: false,
      error: null,
      lastAuditLogId:
        action.postedFlightEngineId === state.postedFlightEngineAudit.selectedId
          ? state.postedFlightEngineAudit.lastAuditLogId
          : null
    }
  })),

  on(actions.PostedFlightEngineAuditLoaded, (state, action) => ({
    ...state,
    postedFlightEngineAudit: {
      ...state.postedFlightEngineAudit,
      ...(!state.postedFlightEngineAudit.lastAuditLogId
        ? auditLogAdapter.setAll(action.audits.resultSet, state.postedFlightEngineAudit)
        : auditLogAdapter.addMany(action.audits.resultSet, state.postedFlightEngineAudit)),
      loading: false,
      loaded: true,
      error: null,
      selectedId: action.postedFlightEngineId,
      pageNumber: action.audits.pageNumber,
      lastAuditLogId: Math.min(...action.audits.resultSet.map(r => +r.auditLogId))
    }
  })),

  on(actions.LoadPostedFlightComponentAudit, (state, action) => ({
    ...state,
    postedFlightComponentAudit: {
      ...state.postedFlightComponentAudit,
      loading: true,
      loaded: false,
      error: null,
      lastAuditLogId:
        action.postedFlightComponentId === state.postedFlightComponentAudit.selectedId
          ? state.postedFlightComponentAudit.lastAuditLogId
          : null
    }
  })),

  on(actions.PostedFlightComponentAuditLoaded, (state, action) => ({
    ...state,
    postedFlightComponentAudit: {
      ...state.postedFlightComponentAudit,
      ...(!state.postedFlightComponentAudit.lastAuditLogId
        ? auditLogAdapter.setAll(action.audits.resultSet, state.postedFlightComponentAudit)
        : auditLogAdapter.addMany(action.audits.resultSet, state.postedFlightComponentAudit)),
      loading: false,
      loaded: true,
      error: null,
      selectedId: action.postedFlightComponentId,
      pageNumber: action.audits.pageNumber,
      lastAuditLogId: Math.min(...action.audits.resultSet.map(r => +r.auditLogId))
    }
  })),

  on(actions.LoadPostedFlightFuelAudit, (state, action) => ({
    ...state,
    postedFlightFuelAudit: {
      ...state.postedFlightFuelAudit,
      loading: true,
      loaded: false,
      error: null,
      lastAuditLogId:
        action.postedFlightId === state.postedFlightFuelAudit.selectedId
          ? state.postedFlightFuelAudit.lastAuditLogId
          : null
    }
  })),

  on(actions.PostedFlightFuelAuditLoaded, (state, action) => ({
    ...state,
    postedFlightFuelAudit: {
      ...state.postedFlightFuelAudit,
      ...(!state.postedFlightFuelAudit.lastAuditLogId
        ? auditLogAdapter.setAll(action.audits.resultSet, state.postedFlightFuelAudit)
        : auditLogAdapter.addMany(action.audits.resultSet, state.postedFlightFuelAudit)),
      loading: false,
      loaded: true,
      error: null,
      selectedId: action.postedFlightId,
      pageNumber: action.audits.pageNumber,
      lastAuditLogId: Math.min(...action.audits.resultSet.map(r => +r.auditLogId))
    }
  })),

  on(actions.LoadPostedFlightAdditionalDetailAudit, (state, action) => ({
    ...state,
    postedFlightAdditionalDetailAudit: {
      ...state.postedFlightAdditionalDetailAudit,
      loading: true,
      loaded: false,
      error: null,
      lastAuditLogId:
        action.postedFlightId === state.postedFlightAdditionalDetailAudit.selectedId
          ? state.postedFlightAdditionalDetailAudit.lastAuditLogId
          : null
    }
  })),

  on(actions.PostedFlightAdditionalDetailAuditLoaded, (state, action) => ({
    ...state,
    postedFlightAdditionalDetailAudit: {
      ...state.postedFlightAdditionalDetailAudit,
      ...(!state.postedFlightAdditionalDetailAudit.lastAuditLogId
        ? auditLogAdapter.setAll(action.audits.resultSet, state.postedFlightAdditionalDetailAudit)
        : auditLogAdapter.addMany(
            action.audits.resultSet,
            state.postedFlightAdditionalDetailAudit
          )),
      loading: false,
      loaded: true,
      error: null,
      selectedId: action.postedFlightId,
      pageNumber: action.audits.pageNumber,
      lastAuditLogId: Math.min(...action.audits.resultSet.map(r => +r.auditLogId))
    }
  })),

  on(actions.LoadOilFluidAudit, (state, action) => ({
    ...state,
    oilFluidAudit: {
      ...state.oilFluidAudit,
      loading: true,
      loaded: false,
      error: null,
      lastAuditLogId:
        action.postedFlightId === state.oilFluidAudit.selectedId
          ? state.oilFluidAudit.lastAuditLogId
          : null
    }
  })),

  on(actions.OilFluidAuditLoaded, (state, action) => ({
    ...state,
    oilFluidAudit: {
      ...state.oilFluidAudit,
      ...(!state.oilFluidAudit.lastAuditLogId
        ? auditLogAdapter.setAll(action.audits.resultSet, state.oilFluidAudit)
        : auditLogAdapter.addMany(action.audits.resultSet, state.oilFluidAudit)),
      loading: false,
      loaded: true,
      error: null,
      selectedId: action.postedFlightId,
      pageNumber: action.audits.pageNumber,
      lastAuditLogId: Math.min(...action.audits.resultSet.map(r => +r.auditLogId))
    }
  })),

  on(actions.LoadEngineOilFluidAudit, (state, action) => ({
    ...state,
    engineOilFluidAudit: {
      ...state.engineOilFluidAudit,
      loading: true,
      loaded: false,
      error: null,
      lastAuditLogId:
        action.postedFlightEngineId === state.engineOilFluidAudit.selectedId
          ? state.engineOilFluidAudit.lastAuditLogId
          : null
    }
  })),

  on(actions.EngineOilFluidAuditLoaded, (state, action) => ({
    ...state,
    engineOilFluidAudit: {
      ...state.engineOilFluidAudit,
      ...(!state.engineOilFluidAudit.lastAuditLogId
        ? auditLogAdapter.setAll(action.audits.resultSet, state.engineOilFluidAudit)
        : auditLogAdapter.addMany(action.audits.resultSet, state.engineOilFluidAudit)),
      loading: false,
      loaded: true,
      error: null,
      selectedId: action.postedFlightEngineId,
      pageNumber: action.audits.pageNumber,
      lastAuditLogId: Math.min(...action.audits.resultSet.map(r => +r.auditLogId))
    }
  })),

  on(actions.LoadComponentOilFluidAudit, (state, action) => ({
    ...state,
    componentOilFluidAudit: {
      ...state.componentOilFluidAudit,
      loading: true,
      loaded: false,
      error: null,
      lastAuditLogId:
        action.postedFlightComponentId === state.componentOilFluidAudit.selectedId
          ? state.componentOilFluidAudit.lastAuditLogId
          : null
    }
  })),

  on(actions.ComponentOilFluidAuditLoaded, (state, action) => ({
    ...state,
    componentOilFluidAudit: {
      ...state.componentOilFluidAudit,
      ...(!state.componentOilFluidAudit.lastAuditLogId
        ? auditLogAdapter.setAll(action.audits.resultSet, state.componentOilFluidAudit)
        : auditLogAdapter.addMany(action.audits.resultSet, state.componentOilFluidAudit)),
      loading: false,
      loaded: true,
      error: null,
      selectedId: action.postedFlightComponentId,
      pageNumber: action.audits.pageNumber,
      lastAuditLogId: Math.min(...action.audits.resultSet.map(r => +r.auditLogId))
    }
  })),

  on(actions.LoadPostedFlightDeAntiIceAudit, (state, action) => ({
    ...state,
    postedFlightDeAntiIceAudit: {
      ...state.postedFlightDeAntiIceAudit,
      loading: true,
      loaded: false,
      error: null,
      lastAuditLogId:
        action.postedFlightId === state.postedFlightDeAntiIceAudit.selectedId
          ? state.postedFlightDeAntiIceAudit.lastAuditLogId
          : null
    }
  })),

  on(actions.PostedFlightDeAntiIceAuditLoaded, (state, action) => ({
    ...state,
    postedFlightDeAntiIceAudit: {
      ...state.postedFlightDeAntiIceAudit,
      ...(!state.postedFlightDeAntiIceAudit.lastAuditLogId
        ? auditLogAdapter.setAll(action.audits.resultSet, state.postedFlightDeAntiIceAudit)
        : auditLogAdapter.addMany(action.audits.resultSet, state.postedFlightDeAntiIceAudit)),
      loading: false,
      loaded: true,
      error: null,
      selectedId: action.postedFlightId,
      pageNumber: action.audits.pageNumber,
      lastAuditLogId: Math.min(...action.audits.resultSet.map(r => +r.auditLogId))
    }
  })),

  on(actions.LoadPostedFlightNotesAudit, (state, action) => ({
    ...state,
    postedFlightNotesAudit: {
      ...state.postedFlightNotesAudit,
      loading: true,
      loaded: false,
      error: null,
      lastAuditLogId:
        action.postedFlightId === state.postedFlightNotesAudit.selectedId
          ? state.postedFlightNotesAudit.lastAuditLogId
          : null
    }
  })),

  on(actions.PostedFlightNotesAuditLoaded, (state, action) => ({
    ...state,
    postedFlightNotesAudit: {
      ...state.postedFlightNotesAudit,
      ...(!state.postedFlightNotesAudit.lastAuditLogId
        ? auditLogAdapter.setAll(action.audits.resultSet, state.postedFlightNotesAudit)
        : auditLogAdapter.addMany(action.audits.resultSet, state.postedFlightNotesAudit)),
      loading: false,
      loaded: true,
      error: null,
      selectedId: action.postedFlightId,
      pageNumber: action.audits.pageNumber,
      lastAuditLogId: Math.min(...action.audits.resultSet.map(r => +r.auditLogId))
    }
  })),

  on(actions.LoadFuelUpliftAudit, (state, action) => ({
    ...state,
    fuelUpliftAudit: {
      ...state.fuelUpliftAudit,
      loading: true,
      loaded: false,
      error: null,
      lastAuditLogId:
        action.postedFlightId === state.fuelUpliftAudit.selectedId
          ? state.fuelUpliftAudit.lastAuditLogId
          : null
    }
  })),

  on(actions.FuelUpliftAuditLoaded, (state, action) => ({
    ...state,
    fuelUpliftAudit: {
      ...state.fuelUpliftAudit,
      ...(!state.fuelUpliftAudit.lastAuditLogId
        ? auditLogAdapter.setAll(action.audits.resultSet, state.fuelUpliftAudit)
        : auditLogAdapter.addMany(action.audits.resultSet, state.fuelUpliftAudit)),
      loading: false,
      loaded: true,
      error: null,
      selectedId: action.postedFlightId,
      pageNumber: action.audits.pageNumber,
      lastAuditLogId: Math.min(...action.audits.resultSet.map(r => +r.auditLogId))
    }
  })),

  on(actions.LoadBusinessCategoryAudit, (state, action) => ({
    ...state,
    businessCategoryAudit: {
      ...state.businessCategoryAudit,
      loading: true,
      loaded: false,
      error: null,
      lastAuditLogId:
        action.flightId === state.businessCategoryAudit.selectedId
          ? state.businessCategoryAudit.lastAuditLogId
          : null
    }
  })),

  on(actions.BusinessCategoryAuditLoaded, (state, action) => ({
    ...state,
    businessCategoryAudit: {
      ...state.businessCategoryAudit,
      ...(!state.businessCategoryAudit.lastAuditLogId
        ? auditLogAdapter.setAll(action.audits.resultSet, state.businessCategoryAudit)
        : auditLogAdapter.addMany(action.audits.resultSet, state.businessCategoryAudit)),
      loading: false,
      loaded: true,
      error: null,
      selectedId: action.flightId,
      pageNumber: action.audits.pageNumber,
      lastAuditLogId: Math.min(...action.audits.resultSet.map(r => +r.auditLogId))
    }
  })),

  on(actions.LoadDepartmentAudit, (state, action) => ({
    ...state,
    departmentAudit: {
      ...state.departmentAudit,
      loading: true,
      loaded: false,
      error: null,
      lastAuditLogId:
        action.flightId === state.departmentAudit.selectedId
          ? state.departmentAudit.lastAuditLogId
          : null
    }
  })),

  on(actions.DepartmentAuditLoaded, (state, action) => ({
    ...state,
    departmentAudit: {
      ...state.departmentAudit,
      ...(!state.departmentAudit.lastAuditLogId
        ? auditLogAdapter.setAll(action.audits.resultSet, state.departmentAudit)
        : auditLogAdapter.addMany(action.audits.resultSet, state.departmentAudit)),
      loading: false,
      loaded: true,
      error: null,
      selectedId: action.flightId,
      pageNumber: action.audits.pageNumber,
      lastAuditLogId: Math.min(...action.audits.resultSet.map(r => +r.auditLogId))
    }
  })),

  on(actions.LoadLogbookAudit, (state, action) => ({
    ...state,
    logbookAudit: {
      ...state.logbookAudit,
      loading: true,
      loaded: false,
      error: null,
      lastAuditLogId:
        action.logbookId === state.logbookAudit.selectedId
          ? state.logbookAudit.lastAuditLogId
          : null
    }
  })),

  on(actions.LogbookAuditLoaded, (state, action) => ({
    ...state,
    logbookAudit: {
      ...state.logbookAudit,
      ...(!state.logbookAudit.lastAuditLogId
        ? auditLogAdapter.setAll(action.audits.resultSet, state.logbookAudit)
        : auditLogAdapter.addMany(action.audits.resultSet, state.logbookAudit)),
      loading: false,
      loaded: true,
      error: null,
      selectedId: action.logbookId,
      pageNumber: action.audits.pageNumber,
      lastAuditLogId: Math.min(...action.audits.resultSet.map(r => +r.auditLogId))
    }
  })),

  on(actions.LoadCrewMemberDutyAudit, (state, action) => ({
    ...state,
    crewMemberDutyAudit: {
      ...state.crewMemberDutyAudit,
      loading: true,
      loaded: false,
      error: null,
      lastAuditLogId:
        action.crewMemberDutyId === state.crewMemberDutyAudit.selectedId
          ? state.crewMemberDutyAudit.lastAuditLogId
          : null
    }
  })),

  on(actions.CrewMemberDutyAuditLoaded, (state, action) => ({
    ...state,
    crewMemberDutyAudit: {
      ...state.crewMemberDutyAudit,
      ...(!state.crewMemberDutyAudit.lastAuditLogId
        ? auditLogAdapter.setAll(action.audits.resultSet, state.crewMemberDutyAudit)
        : auditLogAdapter.addMany(action.audits.resultSet, state.crewMemberDutyAudit)),
      loading: false,
      loaded: true,
      error: null,
      selectedId: action.crewMemberDutyId,
      pageNumber: action.audits.pageNumber,
      lastAuditLogId: Math.min(...action.audits.resultSet.map(r => +r.auditLogId))
    }
  })),

  on(actions.LoadAirFrameLandingsAuditAction, (state, action) => ({
    ...state,
    airframeLandingsAudit: {
      ...state.airframeLandingsAudit,
      loading: true,
      loaded: false,
      error: null,
      lastAuditLogId:
        action.postedFlightId === state.airframeLandingsAudit.selectedId
          ? state.airframeLandingsAudit.lastAuditLogId
          : null
    }
  })),

  on(actions.AirFrameLandingsAuditLoadedAction, (state, action) => ({
    ...state,
    airframeLandingsAudit: {
      ...state.airframeLandingsAudit,
      ...(!state.airframeLandingsAudit.lastAuditLogId
        ? auditLogAdapter.setAll(action.audits.resultSet, state.airframeLandingsAudit)
        : auditLogAdapter.addMany(action.audits.resultSet, state.airframeLandingsAudit)),
      loading: false,
      loaded: true,
      error: null,
      selectedId: action.postedFlightId,
      pageNumber: action.audits.pageNumber,
      lastAuditLogId: Math.min(...action.audits.resultSet.map(r => +r.auditLogId))
    }
  })),

  on(actions.LoadEngineCyclesAuditAction, (state, action) => ({
    ...state,
    engineCyclesAudit: {
      ...state.engineCyclesAudit,
      loading: true,
      loaded: false,
      error: null,
      lastAuditLogId:
        action.postedFlightEngineId === state.engineCyclesAudit.selectedId
          ? state.engineCyclesAudit.lastAuditLogId
          : null
    }
  })),

  on(actions.EngineCyclesAuditLoadedAction, (state, action) => ({
    ...state,
    engineCyclesAudit: {
      ...state.engineCyclesAudit,
      ...(!state.engineOilFluidAudit.lastAuditLogId
        ? auditLogAdapter.setAll(action.audits.resultSet, state.engineCyclesAudit)
        : auditLogAdapter.addMany(action.audits.resultSet, state.engineCyclesAudit)),
      loading: false,
      loaded: true,
      error: null,
      selectedId: action.postedFlightEngineId,
      pageNumber: action.audits.pageNumber,
      lastAuditLogId: Math.min(...action.audits.resultSet.map(r => +r.auditLogId))
    }
  })),
  //VORCheck Data
  on(actions.LoadVORCheckDataAuditAction, (state, action) => ({
    ...state,
    vorcheckDataAudit: {
      ...state.vorcheckDataAudit,
      loading: true,
      loaded: false,
      error: null,
      lastAuditLogId:
        action.aircraftProfileId === state.vorcheckDataAudit.selectedId
          ? state.vorcheckDataAudit.lastAuditLogId
          : null
    }
  })),

  on(actions.VORCheckDataAuditLoadedAction, (state, action) => ({
    ...state,
    vorcheckDataAudit: {
      ...state.vorcheckDataAudit,
      ...(!state.vorcheckDataAudit.lastAuditLogId
        ? auditLogAdapter.setAll(action.audits.resultSet, state.vorcheckDataAudit)
        : auditLogAdapter.addMany(action.audits.resultSet, state.vorcheckDataAudit)),
      loading: false,
      loaded: true,
      error: null,
      selectedId: action.aircraftProfileId,
      pageNumber: action.audits.pageNumber,
      lastAuditLogId: Math.min(...action.audits.resultSet.map(r => +r.auditLogId))
    }
  })),

  on(actions.LoadPreFlightChecklistUserESignaturesAudit, (state, action) => ({
    ...state,
    preFlightChecklistUserESignaturesAudit: {
      ...state.preFlightChecklistUserESignaturesAudit,
      loading: true,
      loaded: false,
      error: null,
      lastAuditLogId:
        action.postedFlightId === state.preFlightChecklistUserESignaturesAudit.selectedId
          ? state.preFlightChecklistUserESignaturesAudit.lastAuditLogId
          : null
    }
  })),

  on(actions.PreFlightChecklistUserESignaturesAuditLoaded, (state, action) => ({
    ...state,
    preFlightChecklistUserESignaturesAudit: {
      ...state.preFlightChecklistUserESignaturesAudit,
      ...(!state.preFlightChecklistUserESignaturesAudit.lastAuditLogId
        ? auditLogAdapter.setAll(
            action.audits.resultSet,
            state.preFlightChecklistUserESignaturesAudit
          )
        : auditLogAdapter.addMany(
            action.audits.resultSet,
            state.preFlightChecklistUserESignaturesAudit
          )),
      loading: false,
      loaded: true,
      error: null,
      selectedId: action.postedFlightId,
      pageNumber: action.audits.pageNumber,
      lastAuditLogId: Math.min(...action.audits.resultSet.map(r => +r.auditLogId))
    }
  })),

  on(actions.LoadPostedFlightChecklistUserESignaturesAudit, (state, action) => ({
    ...state,
    postedFlightChecklistUserESignaturesAudit: {
      ...state.postedFlightChecklistUserESignaturesAudit,
      loading: true,
      loaded: false,
      error: null,
      lastAuditLogId:
        action.postedFlightId === state.postedFlightChecklistUserESignaturesAudit.selectedId
          ? state.postedFlightChecklistUserESignaturesAudit.lastAuditLogId
          : null
    }
  })),

  on(actions.PostedFlightChecklistUserESignaturesAuditLoaded, (state, action) => ({
    ...state,
    postedFlightChecklistUserESignaturesAudit: {
      ...state.postedFlightChecklistUserESignaturesAudit,
      ...(!state.postedFlightChecklistUserESignaturesAudit.lastAuditLogId
        ? auditLogAdapter.setAll(
            action.audits.resultSet,
            state.postedFlightChecklistUserESignaturesAudit
          )
        : auditLogAdapter.addMany(
            action.audits.resultSet,
            state.postedFlightChecklistUserESignaturesAudit
          )),
      loading: false,
      loaded: true,
      error: null,
      selectedId: action.postedFlightId,
      pageNumber: action.audits.pageNumber,
      lastAuditLogId: Math.min(...action.audits.resultSet.map(r => +r.auditLogId))
    }
  })),

  on(actions.LoadFlightLogUserESignaturesAudit, (state, action) => ({
    ...state,
    flightLogUserESignaturesAudit: {
      ...state.flightLogUserESignaturesAudit,
      loading: true,
      loaded: false,
      error: null,
      lastAuditLogId:
        action.postedFlightId === state.flightLogUserESignaturesAudit.selectedId
          ? state.flightLogUserESignaturesAudit.lastAuditLogId
          : null
    }
  })),

  on(actions.FlightLogUserESignaturesAuditLoaded, (state, action) => ({
    ...state,
    flightLogUserESignaturesAudit: {
      ...state.flightLogUserESignaturesAudit,
      ...(!state.flightLogUserESignaturesAudit.lastAuditLogId
        ? auditLogAdapter.setAll(action.audits.resultSet, state.flightLogUserESignaturesAudit)
        : auditLogAdapter.addMany(action.audits.resultSet, state.flightLogUserESignaturesAudit)),
      loading: false,
      loaded: true,
      error: null,
      selectedId: action.postedFlightId,
      pageNumber: action.audits.pageNumber,
      lastAuditLogId: Math.min(...action.audits.resultSet.map(r => +r.auditLogId))
    }
  })),

  on(actions.LoadSquawkUserESignaturesAudit, (state, action) => ({
    ...state,
    squawkUserESignaturesAudit: {
      ...state.squawkUserESignaturesAudit,
      loading: true,
      loaded: false,
      error: null,
      lastAuditLogId:
        action.postedFlightId === state.squawkUserESignaturesAudit.selectedId
          ? state.squawkUserESignaturesAudit.lastAuditLogId
          : null
    }
  })),

  on(actions.SquawkUserESignaturesAuditLoaded, (state, action) => ({
    ...state,
    squawkUserESignaturesAudit: {
      ...state.squawkUserESignaturesAudit,
      ...(!state.squawkUserESignaturesAudit.lastAuditLogId
        ? auditLogAdapter.setAll(action.audits.resultSet, state.squawkUserESignaturesAudit)
        : auditLogAdapter.addMany(action.audits.resultSet, state.squawkUserESignaturesAudit)),
      loading: false,
      loaded: true,
      error: null,
      selectedId: action.postedFlightId,
      pageNumber: action.audits.pageNumber,
      lastAuditLogId: Math.min(...action.audits.resultSet.map(r => +r.auditLogId))
    }
  }))
);

export function reducer(state: State | undefined, action: Action) {
  return postedFlightReducer(state, action);
}
